<template>
  <div>
  	ERROR 404
    <p>{{trans['test']}}</p>
  </div>
</template>

<script>
export default {
  name: 'error_404',
  created: function() {
  	
  }
}
</script>
</script>
